// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2026project/q1/2026merchants/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getList = (page: number, workType: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      workType,
      search,
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: { id },
  });
};

// 通用付费投票信息
export const vote = (data: any) => {
  return http.post(
    `vote/public/pay/controller.php?enews=vote&act_id=${data.act_id}`,
    qs.stringify(data),
    {},
  );
};

// 通用用户信息
export const userInfo = (actId: number, unionid: any) => {
  return http.get(
    `vote/public/pay/controller.php?enews=user-info&act_id=${actId}&unionid=${unionid}`,
    {
      headers: {},
    },
  );
};

// 余额
export const voteNum = (actId: number, unionid?: any) => {
  return http.get(
    `vote/public/pay/controller.php?enews=voteNum&act_id=${actId}&unionid=${unionid}`,
    {
      headers: {},
    },
  );
};

// 消费记录
export const consumption = (actId: number, page: number, unionid?: any) => {
  return http.get(
    `vote/public/pay/controller.php?enews=consumption&act_id=${actId}&page=${page}&unionid=${unionid}`,
    {
      headers: {},
    },
  );
};

// 充值记录
export const recharge = (actId: number, page: number, unionid?: any) => {
  return http.get(
    `vote/public/pay/controller.php?enews=recharge&act_id=${actId}&page=${page}&unionid=${unionid}`,
    {
      headers: {},
    },
  );
};

// 通用支付
export const pay = (data: any) => {
  return http.post(`vote/public/pay/pay.php`, qs.stringify(data));
};

export { getBaseInfo, getNews, getList, getDetail };
